import { ScreenSize } from '../../../api/ScreenSize';
import { Lightning, Log, Registry } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';
import { AtvKeyboardInput } from '../../../components/keyboard/AtvKeyboardInput';
import { Button } from '../../../components/shared/Button';
import { AtvKeyboardService } from '../../../components/keyboard/AtvKeyboardService';
import {
  ErrorTranslationKeys,
  MyStuffTranslationKeys,
  PopupTranslationKeys,
} from '../../../api/models/TranslationKeys';
import { PincodeApi } from '../../../api/profile/PincodeApi';

const Constants = {
  textTop: 100,
  inputTop: 470,
  buttonsTop: 580,
  buttonWidth: ScreenSize.w / 3 / 2,
  buttonsMargin: 32,
  errorTop: 680,
  focus: 0xff245c83,
  unfocus: 0xff52626c,
  verticalMargin: 20,
  smallVerticalMargin: 5,
};

export class PinChangeDialog extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      rect: true,
      color: Theme.Colors.Option.Background.Page,
      h: ScreenSize.h,
      w: ScreenSize.w,
      Container: {
        y: Constants.textTop,
        w: w => w,
        h: h => h - Constants.textTop,
        flex: {
          direction: 'column',
        },
        Label: {
          flexItem: {
            marginTop: Constants.verticalMargin,
          },
          y: 0,
          x: w => w / 2,
          mountX: 0.5,
          text: {
            text: '',
            ...Theme.Fonts.CodeInput.Title,
          },
        },
        LabelOldPassword: {
          flexItem: {
            marginTop: Constants.verticalMargin,
          },
          x: w => w / 2,
          mountX: 0.5,
          text: {
            text: '',
            ...Theme.Fonts.Normal,
          },
        },
        InputFieldOld: {
          flexItem: {
            marginTop: Constants.smallVerticalMargin,
          },
          mountX: 0.5,
          x: w => w / 2,
          w: 600,
          h: 62,
          type: AtvKeyboardInput,
          passwordMode: true,
          inputColors: {
            focus: Constants.focus,
            unfocus: Constants.unfocus,
          },
          textColor: 0xffffffff,
          cursorColor: 0xffffffff,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: 6,
          },
          signals: {
            onFinished: '_inputDone',
          },
        },
        LabelNewPassword: {
          flexItem: {
            marginTop: Constants.verticalMargin,
          },
          x: w => w / 2,
          mountX: 0.5,
          text: {
            text: '',
            ...Theme.Fonts.Normal,
          },
        },
        InputFieldNew: {
          flexItem: {
            marginTop: Constants.smallVerticalMargin,
          },
          mountX: 0.5,
          x: w => w / 2,
          w: 600,
          h: 62,
          type: AtvKeyboardInput,
          passwordMode: true,
          inputColors: {
            focus: Constants.focus,
            unfocus: Constants.unfocus,
          },
          textColor: 0xffffffff,
          cursorColor: 0xffffffff,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: 6,
          },
          signals: {
            onFinished: '_inputDone',
          },
        },
        LabelRepeatPassword: {
          flexItem: {
            marginTop: Constants.verticalMargin,
          },
          x: w => w / 2,
          mountX: 0.5,
          text: {
            text: '',
            ...Theme.Fonts.Normal,
          },
        },
        InputFieldRepeat: {
          flexItem: {
            marginTop: Constants.smallVerticalMargin,
          },
          mountX: 0.5,
          x: w => w / 2,
          w: 600,
          h: 62,
          type: AtvKeyboardInput,
          passwordMode: true,
          inputColors: {
            focus: Constants.focus,
            unfocus: Constants.unfocus,
          },
          textColor: 0xffffffff,
          cursorColor: 0xffffffff,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: 6,
          },
          signals: {
            onFinished: '_inputDone',
          },
        },
        Buttons: {
          flexItem: {
            marginTop: Constants.verticalMargin,
          },
          x: w => w / 2 - Constants.buttonsMargin / 2,
          w: Constants.buttonWidth * 2 + Constants.buttonsMargin,
          h: 60,
          mountX: 0.5,
          Cancel: {
            type: Button,
            buttonMode: 'dialog',
            w: Constants.buttonWidth,
            label: '',
            signals: {
              onActivate: '_handleCancel',
            },
          },
          Confirm: {
            x: Constants.buttonWidth + Constants.buttonsMargin,
            type: Button,
            buttonMode: 'dialog',
            w: Constants.buttonWidth,
            label: '',
            signals: {
              onActivate: '_handleConfirm',
            },
          },
        },
        ErrorMsg: {
          flexItem: {
            marginTop: Constants.verticalMargin,
          },
          // y: Constants.errorTop,
          x: w => w / 2,
          mountX: 0.5,
          // h: h => h,
          text: {
            text: '',
            ...Theme.Fonts.CodeInput.ErrorMsg,
            textAlign: 'center',
          },
        },
      },
    };
  }

  _init() {
    AtvKeyboardService.init(this);
    this.focusX = 1;
    this.focusY = 0;
    if (this.adult === undefined) this.adult = false;
    this.errorMsg = '';
    if (this.adult) {
      this.tag('Label').text.text = this.backend.translations.forKey(
        MyStuffTranslationKeys.mystuff_change_adult_pincode
      );
    } else {
      this.tag('Label').text.text = this.backend.translations.forKey(MyStuffTranslationKeys.mystuff_change_vod_pincode);
    }

    this.tag('LabelOldPassword').text.text = this.backend.translations.forKey(
      MyStuffTranslationKeys.mystuff_old_pincode
    );
    this.tag('LabelNewPassword').text.text = this.backend.translations.forKey(
      MyStuffTranslationKeys.mystuff_new_pincode
    );
    this.tag('LabelRepeatPassword').text.text = this.backend.translations.forKey(
      MyStuffTranslationKeys.mystuff_confirm_pincode
    );

    this.tag('InputFieldOld').numpadMode = true;
    this.tag('InputFieldNew').numpadMode = true;
    this.tag('InputFieldRepeat').numpadMode = true;

    this.tag('Confirm').label = this.backend.translations.forKey(MyStuffTranslationKeys.mystuff_change_pincode);
    this.tag('Cancel').label = this.backend.translations.forKey(PopupTranslationKeys.popup_btn_cancel);
  }

  _firstActive() {
    // defer for the keyboard to initialize first
    Registry.setTimeout(() => {
      this.tag('InputFieldOld')._handleEnter();
      this._refocus();
    });
  }

  set errorMsg(val) {
    this.tag('ErrorMsg').visible = !!val;
    this.tag('ErrorMsg').text.text = val;
  }

  _handleLeft() {
    this.focusX = Math.max(this.focusX - 1, 0);
  }

  _handleRight() {
    this.focusX = Math.min(this.focusX + 1, this.tag('Buttons').children.length - 1);
  }

  _handleDown() {
    this.focusX = 1;
    this.focusY = Math.min(this.focusY + 1, 3);
  }

  _handleUp() {
    this.focusX = 1;
    this.focusY = Math.max(this.focusY - 1, 0);
  }

  _handleBack() {
    this.onCancel && this.onCancel();
    this.fireAncestors('$closeDialog');
  }

  _inputDone() {
    this._handleDown();
    Registry.setTimeout(() => {
      if (this.focusY !== 3) {
        this._getFocused()._handleEnter();
        this._refocus();
      }
    });
  }

  _handleConfirm() {
    const oldPin = this.tag('InputFieldOld').input;
    const newPin = this.tag('InputFieldNew').input;
    const repeatPin = this.tag('InputFieldRepeat').input;
    this.errorMsg = '';
    if (oldPin.length !== 4 || newPin.length !== 4 || repeatPin.length !== 4) {
      this.errorMsg = this.backend.translations.forKey(ErrorTranslationKeys.error_invalid_pin);
      return;
    }
    if (newPin === repeatPin) {
      /**\
       * @type {ISessionChangePinRequest}
       */
      const data = {
        type: this.adult ? 'ADULT' : 'VOD',
        oldPincode: oldPin,
        newPincode: newPin,
      };
      PincodeApi.updatePinCode(this.backend, data)
        .then(() => {
          this.errorMsg = this.backend.translations.forKey(MyStuffTranslationKeys.mystuff_pincodechange_succes);
          this.fireAncestors(
            '$showToast',
            this.backend.translations.forKey(MyStuffTranslationKeys.mystuff_pincodechange_succes),
            4000
          );
          this.fireAncestors('$closeDialog');
        })
        .catch(err => {
          Log.error('[PinChangeDialog] pin change error', err);
          this.errorMsg = this.backend.translations.forKey(MyStuffTranslationKeys.mystuff_pincodechange_failed);
        });
    } else {
      this.errorMsg = this.backend.translations.forKey(MyStuffTranslationKeys.mystuff_pincodes_must_match);
    }
  }

  _handleCancel() {
    this.fireAncestors('$closeDialog');
  }

  _getFocusable() {
    return [this.tag('InputFieldOld'), this.tag('InputFieldNew'), this.tag('InputFieldRepeat'), this.tag('Buttons')];
  }

  _getFocused() {
    if (AtvKeyboardService.instance && AtvKeyboardService.instance.isOpen) {
      return AtvKeyboardService.instance.keyboard;
    }
    if (this.focusY === 3) return this.tag('Buttons').children[this.focusX];
    return this._getFocusable()[this.focusY];
  }

  _detach() {
    AtvKeyboardService.removeInstance();
  }
}
